import { render } from "./ViewTicket.vue?vue&type=template&id=6a540c98&scoped=true"
import script from "./ViewTicket.vue?vue&type=script&lang=js"
export * from "./ViewTicket.vue?vue&type=script&lang=js"

import "./ViewTicket.vue?vue&type=style&index=0&id=6a540c98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a540c98"]])

export default __exports__